import { put, call } from 'redux-saga/effects';
import { mastersCreateAPI, mastersSearchAPI, mastersUpdateAPI } from 'src/api/MastersApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { MASTERS_ACTIONS } from '../actions/MastersActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true, caseSensitiveSearchProperties = [],
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(mastersSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
                caseSensitiveSearchProperties,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: MASTERS_ACTIONS.MASTERS_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: MASTERS_ACTIONS.MASTERS_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(mastersSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            // DATA NO FOUND
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        // add in reducer
        yield put({
            type: MASTERS_ACTIONS.MASTERS_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(mastersCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        }));

        // add in reducer
        yield put({
            type: MASTERS_ACTIONS.MASTERS_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: MASTERS_ACTIONS.MASTERS_UPSERT_ERROR,
        });
    }
}

function* update(masterId, payload) {
    try {
        yield call(mastersUpdateAPI, {
            masterId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: masterId });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: MASTERS_ACTIONS.MASTERS_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(MASTERS_ACTIONS.MASTERS_SEARCH, search),
    takeFirstSagaUtil(MASTERS_ACTIONS.MASTERS_UPSERT, upsert),
    takeFirstSagaUtil(MASTERS_ACTIONS.MASTERS_EDIT, edit),
];
